// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.next-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 5px;
  padding: 0 6px;
}

.next-container .view-summary {
  font-size: 14px;
  font-weight: 700;
  padding: 6px 10px;
  border: none;
  border-radius: 6px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  background-color: var(--white-blue);
  color: var(--dark-blue);
}


.floating-share-button {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.floating-share-button  .share-img {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--light-blue);
  img {
    width: 100%;
  }
}

.floating-bar .box-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border: 1px solid var(--light-blue);
  padding: 4px;
  border-radius: 8px;
  gap: 18px;
  animation: appearFromRight 0.5s;
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 6px;
  }
  img {
    width: 26px;
  }
}

@keyframes appearFromRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FloatingBarButtons/FloatingBarButtons.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,2BAAsB;EAAtB,sBAAsB;EACtB,mCAAmC;EACnC,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".next-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 5px;\n  padding: 0 6px;\n}\n\n.next-container .view-summary {\n  font-size: 14px;\n  font-weight: 700;\n  padding: 6px 10px;\n  border: none;\n  border-radius: 6px;\n  min-width: fit-content;\n  background-color: var(--white-blue);\n  color: var(--dark-blue);\n}\n\n\n.floating-share-button {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n}\n\n.floating-share-button  .share-img {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid var(--light-blue);\n  img {\n    width: 100%;\n  }\n}\n\n.floating-bar .box-buttons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  border: 1px solid var(--light-blue);\n  padding: 4px;\n  border-radius: 8px;\n  gap: 18px;\n  animation: appearFromRight 0.5s;\n  button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    padding: 6px;\n  }\n  img {\n    width: 26px;\n  }\n}\n\n@keyframes appearFromRight {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
